import { UserAnnualPlan } from "./user-annual-plan.model";

export enum SubscriptionType {
  Monthly = "monthly",
  Yearly = "yearly",
}

export type AnnualPlanType = {
  annualPlanTypeId: string;
  name: string;
  subscriptionType: SubscriptionType;
};

export type Subscription = {
  subscriptionId: string;
  subscriptionType: SubscriptionType; // monthly or yearly
  price: number;
  stripeProductId: string;
};

export type AnnualPlanNotification = {
  annualPlanNotificationId: string;
  message: string;
  archived: boolean;
  userAnnualPlan: UserAnnualPlan;
};

export type Sort = {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
};

export type Pageable = {
  sort: Sort;
  offset: number;
  pageSize: number;
  pageNumber: number;
  paged: boolean;
  unpaged: boolean;
};

export interface AnnualPlanNotificationResponse {
  content: AnnualPlanNotification[];
  pageable: Pageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: Sort;
  numberOfElements: number;
  first: boolean;
  empty: boolean;
}

export type OfficeAnnualPlan = {
  isActive?: boolean;
  officeAnnualPlanId: string;
  officeId: string;
  annualPlanType: AnnualPlanType; // See details on annual plan type model above
  subscription: Subscription;
  numSubscribers: number;
};

export type OfficeActivePlan = {
  annualPlanActive: boolean; // Set this to true if activating
  annualPlanDescription: string; // The description from the 3rd step
  singlePlanMonthlySubscriptionId: string;
  singlePlanYearlySubscriptionId: string;
  couplePlanMonthlySubscriptionId: string;
  couplePlanYearlySubscriptionId: string;
  familyPlanMonthlySubscriptionId: string;
  familyPlanYearlySubscriptionId: string;
  seniorPlanMonthlySubscriptionId: string;
  seniorPlanYearlySubscriptionId: string;
  seniorCouplePlanMonthlySubscriptionId: string;
  seniorCouplePlanYearlySubscriptionId: string;
};

export type AnnualPlanServices = {
  serviceId: string;
  annualPlanEnabled: boolean;
  annualPlanDiscountPct: number;
};

export type AnnualPlanServiceFormType = {
  serviceId: string;
  annualPlanEnabled: boolean;
  annualPlanDiscountPct: number;
  name: string;
  price: number;
};

export type AnnualPlanTotals = {
  annualPlanRevenue: number;
  revenueGenerated: number;
  yearlyAnnualPlanSubscribers: number;
  monthlyAnnualPlanSubscribers: number;
  refundAmount?: number;
};

export type PlanType = {
  plan: string;
  subscribers: number;
  revenue: number;
};

export type AnnualPlanRevenueData = {
  subscribersTotal: number;
  revenueTotal: number;
  plans: PlanType[];
};

export enum PlanNames {
  Single = "Individual Plan",
  Couple = "Couples Plan",
  Family = "Family Plan",
  Senior = "Senior Individual Plan",
  "Senior Couple" = "Senior Couples Plan",
}

export type CardDetails = {
  card4Digits: string;
  cardExpirationDate: string;
  cardName: string;
  cardCountry: string;
  cardZipCode: string;
};
